import { BCProduct } from '@cerifi/ecomm/bigcommerce/types/product'
import { Checkbox } from '@cerifi/ui/components/checkbox'
import { Currency } from '@cerifi/ui/components/currency'
import { CheckIcon } from '@cerifi/ui/components/icons'

export const EnrollmentTextbookAddon = ({
  product,
  onCheckedChange,
  checked,
}: {
  product: BCProduct
  onCheckedChange: (isChecked: boolean) => void
  checked: boolean
}) => {
  return (
    <div>
      <label className="block font-medium mb-3">Add-On Print Textbook</label>
      <div className="text-periwinkle flex items-center gap-2 mb-3">
        <CheckIcon />
        eBook Included!
      </div>
      <Checkbox
        aria-label="Add-On Print Textbook"
        data-testid="textbook-add-on-checkbox"
        checked={checked}
        onCheckedChange={(v) => onCheckedChange(v as boolean)}
      >
        <span className="font-normal text-base">
          Print (+
          <Currency dollars={product.price} />)
        </span>
      </Checkbox>
    </div>
  )
}
